@import '../../../src/utils/global.module.less';

// Define baseColor using title-color from global
@baseColor: @title-color;

// Modal styles
:global {
    .wide-modal {
        max-width: 95%;
        width: 1400px;
        margin: 1.75rem auto;
    }
    .wide-modal .modal-body {
        max-height: 70vh;
        overflow-y: auto;
    }
}

// Base layout
.pageContainer {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #f5f7fa;
}

.header {
    background-color: #243a5c;
    color: white;
    padding: 1rem 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .headerTitle {
        font-size: 1.5rem;
        font-weight: 600;
    }
}

.content {
    flex: 1;
    padding: 2rem;
    overflow-y: auto;
}

.container {
    max-width: 1600px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.emptyState {
    text-align: center;
    padding: 3rem;
    color: #6c757d;
    font-size: 1.1rem;
}

// Charts
.chartContainer {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    h3 {
        margin-bottom: 1rem;
        color: #243a5c;
    }
}

// Version Stats
.versionStats {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    h3 {
        margin-bottom: 1rem;
        color: #243a5c;
    }

    .statsGrid {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        gap: 1rem;
        position: relative;
        overflow-x: auto;
        width: 100%;
        flex-wrap: nowrap;

        @media (max-width: 1200px) {
            flex-direction: column;
            align-items: stretch;
            gap: 1rem;
        }
    }

    .versionStat {
        padding: 1.5rem;
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #e9ecef;
        position: relative;
        transition: all 0.2s ease;
        min-width: 300px;
        flex: 0 0 auto;
        
        &:hover {
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
            transform: translateY(-2px);
        }

        &:first-child {
            margin-left: 0;
        }

        &:last-child {
            margin-right: 0;
        }
        
        .versionHeader {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1rem;
            padding-bottom: 1rem;
            border-bottom: 1px solid #e9ecef;
            
            h4 {
                color: #243a5c;
                margin: 0;
                font-size: 1.1rem;
                max-width: 150px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-weight: 600;
            }
        }

        .versionDate {
            font-size: 0.85rem;
            color: #6c757d;
        }

        .statsContent {
            p {
                margin: 0.5rem 0;
                color: #495057;
                font-size: 0.95rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0.5rem 0;

                &:not(:last-child) {
                    border-bottom: 1px dashed #e9ecef;
                }

                span:first-child {
                    color: #6c757d;
                }

                span:last-child {
                    font-weight: 500;
                    color: #243a5c;
                    padding: 0.25rem 0.5rem;
                    background: rgba(36, 58, 92, 0.05);
                    border-radius: 4px;

                    &.high {
                        color: #198754;
                        background: rgba(25, 135, 84, 0.1);
                    }

                    &.medium {
                        color: #ffc107;
                        background: rgba(255, 193, 7, 0.1);
                    }

                    &.low {
                        color: #dc3545;
                        background: rgba(220, 53, 69, 0.1);
                    }
                }
            }
        }
    }

    .versionConnector {
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: white;
        border: 1px solid #e9ecef;
        border-radius: 8px;
        padding: 1rem;
        width: 180px;
        min-width: 180px;
        position: relative;
        z-index: 2;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        transition: all 0.2s ease;
        margin: 0 -0.5rem;

        @media (max-width: 1200px) {
            width: 100%;
            margin: 0;
            min-width: auto;

            &::before, &::after {
                display: none;
            }
        }

        &:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            border-color: #ced4da;
        }

        &::before, &::after {
            content: '';
            position: absolute;
            width: 1.5rem;
            height: 2px;
            background: #e9ecef;
            top: 50%;
            transform: translateY(-50%);
            z-index: -1;
            transition: background-color 0.2s ease;
        }

        &::before {
            left: -1.5rem;
        }

        &::after {
            right: -1.5rem;
        }

        &:hover::before, &:hover::after {
            background: #ced4da;
        }

        .connectorTitle {
            font-size: 0.8rem;
            color: #6c757d;
            text-align: center;
            margin-bottom: 0.75rem;
            font-weight: 500;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        .commonFields {
            font-size: 0.9rem;
            color: #0d6efd;
            text-align: center;
            font-weight: 500;
            margin-bottom: 0.5rem;
            padding: 0.25rem;
            border-radius: 4px;
            background: rgba(13, 110, 253, 0.05);
        }

        .newFields {
            font-size: 0.9rem;
            color: #198754;
            text-align: center;
            font-weight: 500;
            margin-bottom: 0.5rem;
            padding: 0.25rem;
            border-radius: 4px;
            background: rgba(25, 135, 84, 0.05);
        }

        .removedFields {
            font-size: 0.9rem;
            color: #dc3545;
            text-align: center;
            font-weight: 500;
            margin-bottom: 0.5rem;
            padding: 0.25rem;
            border-radius: 4px;
            background: rgba(220, 53, 69, 0.05);
        }

        .comparisonPercent {
            font-size: 1.1rem;
            color: #243a5c;
            text-align: center;
            font-weight: 600;
            margin-top: 0.75rem;
            padding: 0.5rem;
            background: #f8f9fa;
            border-radius: 4px;
            border: 1px solid #e9ecef;
            transition: all 0.2s ease;

            &:hover {
                background: #fff;
                border-color: #ced4da;
            }
        }
    }
}

// Field Accuracy Section
.fieldAccuracy {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    h3 {
        margin-bottom: 1rem;
        color: #243a5c;
    }
}

// Filters
.filters {
    margin-bottom: 1rem;
    gap: 1rem;
}

.filterContainer {
    flex: 1;
    max-width: 300px;
}

.filterInput {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 0.9rem;

    &:focus {
        outline: none;
        border-color: #243a5c;
        box-shadow: 0 0 0 2px rgba(36, 58, 92, 0.1);
    }
}

// Table
.tableContainer {
    overflow-x: auto;
    margin-top: 1rem;
}

.comparisonTable {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    background: white;

    th, td {
        padding: 0.75rem;
        border: 1px solid #e9ecef;
        text-align: center;
    }

    th {
        background: #f8f9fa;
        color: #243a5c;
        font-weight: 600;
        position: sticky;
        top: 0;
        z-index: 1;
    }

    .fieldNameHeader {
        position: sticky;
        left: 0;
        z-index: 2;
        background: #f8f9fa;
        min-width: 200px;
        max-width: 300px;
    }

    .fieldName {
        position: sticky;
        left: 0;
        background: white;
        font-weight: 500;
        color: #243a5c;
        text-align: left;
        z-index: 1;
        min-width: 200px;
        max-width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .versionHeader {
        min-width: 120px;
        max-width: 150px;
        padding: 0.5rem;

        .versionLabel {
            font-weight: 600;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .versionDate {
            font-size: 0.8rem;
            color: #6c757d;
            margin-top: 0.25rem;
        }
    }
}

.accuracyCell {
    cursor: pointer;
    transition: background-color 0.2s;
    min-width: 120px;

    &:hover {
        background-color: #f8f9fa;
    }
}

.accuracyValue {
    font-weight: 500;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    display: inline-block;

    &.high {
        background-color: rgba(40, 167, 69, 0.1);
        color: #28a745;
    }

    &.medium {
        background-color: rgba(255, 193, 7, 0.1);
        color: #ffc107;
    }

    &.low {
        background-color: rgba(220, 53, 69, 0.1);
        color: #dc3545;
    }
}

.matchCount {
    font-size: 0.8rem;
    color: #6c757d;
    margin-top: 0.25rem;
}

.notTested {
    color: #adb5bd;
}

// Modal
.modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modalContent {
    background: white;
    border-radius: 8px;
    width: 90%;
    max-width: 1200px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modalHeader {
    padding: 1rem 1.5rem;
    border-bottom: 1px solid #e9ecef;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
        margin: 0;
        color: #243a5c;
        font-size: 1.25rem;
        max-width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    button {
        background: none;
        border: none;
        font-size: 1.5rem;
        color: #6c757d;
        cursor: pointer;
        padding: 0.25rem;
        line-height: 1;

        &:hover {
            color: #343a40;
        }
    }
}

.modalBody {
    padding: 1.5rem;
    overflow-y: auto;

    table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0;
        
        th, td {
            padding: 0.75rem;
            border: 1px solid #e9ecef;
            text-align: left;
        }

        th {
            background: #f8f9fa;
            color: #243a5c;
            font-weight: 600;
            position: sticky;
            top: 0;
            z-index: 1;
        }

        td {
            vertical-align: top;
            word-break: break-word;
        }
    }
}

.backButton {
    background: transparent;
    color: white;
    border: 1px solid white;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
}

.title {
    font-family: 'LustTextMedium';
    font-size: 22px;
    font-style: italic;
    color: @baseColor;
    margin-bottom: 1rem;
}

.subtitle {
    font-family: 'LustTextMedium';
    font-size: 16px;
    color: @baseColor;
    margin-bottom: 0.5rem;
}

// Stats
.statsContainer {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;
}

.statCard {
    background: white;
    padding: 1rem;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.statValue {
    font-size: 24px;
    font-weight: bold;
    color: @baseColor;
}

.statLabel {
    font-size: 14px;
    color: #657e96;
}

// Result table styles
.resultTable {
    width: 100%;
    overflow-x: auto;
}

.compareTable {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    th {
        background: #f5f5f5;
        padding: 1rem;
        text-align: left;
        font-weight: bold;
        color: @baseColor;
        border-bottom: 2px solid #d0d5dd;
        position: sticky;
        top: 0;
        z-index: 1;
    }

    td {
        padding: 1rem;
        border-bottom: 1px solid #e0e0e0;
        vertical-align: top;
    }
}

.valueCell {
    font-family: monospace;
    white-space: pre-wrap;
    word-break: break-word;
    max-width: 300px;
}

.matchSuccess {
    color: #28a745;
    font-weight: bold;
}

.matchError {
    color: #dc3545;
    font-weight: bold;
}

// Modal
.modalTitle {
    color: @baseColor;
    margin-bottom: 1rem;
    border-bottom: 1px solid #d0d5dd;
    padding-bottom: 0.5rem;
}

.modalLabel {
    font-weight: bold;
    margin-right: 0.5rem;
}

.modalPre {
    background-color: #F9FAFB;
    padding: 1rem;
    border-radius: 4px;
    overflow: auto;
    max-height: 300px;
}

// Compare tables
.compareTable {
    width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 1px solid #e0e0e0;
    font-size: 14px;
    table-layout: fixed;
}

.compareTableHeader {
    background-color: #F9FAFB;
    padding: 0.75rem;
    text-align: center;
    border-bottom: 2px solid #d0d5dd;
    font-weight: bold;
    color: @baseColor;
}

.compareTableCell {
    padding: 0.75rem;
    border-bottom: 1px solid #e0e0e0;
    vertical-align: top;
}

.compareTableMatch {
    color: #0c8a20;
    font-weight: bold;
}

.compareTableMismatch {
    color: #d62b2b;
    font-weight: bold;
}

.compareValue {
    font-family: monospace;
    white-space: pre-wrap;
    word-break: break-word;
}

.modalDialog {
    max-width: 90%;
    width: 1200px;
    margin: 1.75rem auto;
}

.modalBody {
    max-height: 70vh;
    overflow-y: auto;
}

.dashboard {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.fieldVersionInfo {
    font-size: 12px;
    color: #657e96;
    margin-top: 4px;
}

.accuracyValue {
    font-weight: bold;
    font-size: 16px;

    &.high {
        color: #0c8a20;
    }
    
    &.medium {
        color: #f0ad4e;
    }
    
    &.low {
        color: #d62b2b;
    }
}

.sampleCount {
    font-size: 12px;
    color: #657e96;
    margin-top: 4px;
}

.comparisonMatrix {
    width: 100%;
    border-collapse: collapse;
    background: white;
    font-size: 14px;
}

.matrixHeader {
    position: sticky;
    top: 0;
    background: #f5f5f5;
    padding: 1rem;
    text-align: center;
    font-weight: bold;
    color: @baseColor;
    border-bottom: 2px solid #d0d5dd;
    z-index: 1;
    min-width: 120px;

    &:first-child {
        text-align: left;
        left: 0;
        z-index: 2;
        min-width: 200px;
    }
}

.matrixRow {
    &:hover {
        background-color: #f8f9fa;
    }
}

.matrixCell {
    padding: 1rem;
    border-bottom: 1px solid #e0e0e0;
    text-align: center;
    vertical-align: middle;

    &:first-child {
        position: sticky;
        left: 0;
        background: white;
        text-align: left;
        z-index: 1;
        min-width: 200px;

        .matrixRow:hover & {
            background-color: #f8f9fa;
        }
    }

    &.clickable {
        cursor: pointer;
        transition: background-color 0.2s ease;

        &:hover {
            background-color: #f0f2f5;
        }
    }

    &.notTested {
        color: #a0aec0;
        font-style: italic;
        background-color: #fafafa;
    }
} 